import { Breadcrumbs, Link, TablePagination, Typography } from "@mui/material";
import { PageTopBar, ThreeSlotLayout } from "../../../../../common/components/page_top_bar";
import { useMaquinasEquipControleViewModel } from "../../viewModels/maquinas_equip_controle_view_model";
import { GenerateControledePatrimonioControleColumnDefinition } from "./columns";
import { useMemo } from "react";
import { StyledDataGrid } from "../../../../../common/components/styled_data_grid";
import { GetAllControlePatrimonioControleDaoModel } from "../../../domain/models/ControledePatrimonioControleModel";
import { ModalCreateMaquinasequipControle } from "./components/modal_create";
import { Header } from "./components/header";

import DynamicIcon from "../../../../../common/components/dynamic_icon";
import PrimaryButton from "../../../../../common/components/primary_button";
import RefreshButton from "../../../../../common/components/refresh_button";
import DeleteDialog from "../../../../../common/components/delete_dialog";

export const MaquinasEquipControle = () => {
  const viewModel = useMaquinasEquipControleViewModel();

  const columnsDefinition = useMemo(() => {
    return GenerateControledePatrimonioControleColumnDefinition({
      onActionEditar: viewModel.handleControleCentroCustoOpenState,
      onActionDeletar: viewModel.handleControleCentroCustoDeleteOpenState,
      onActionViewItem: viewModel.handleViewItens,
    });
  }, [viewModel.handleControleCentroCustoOpenState, viewModel.handleControleCentroCustoDeleteOpenState, viewModel.handleViewItens]);

  return (
    <>
      <PageTopBar>
        <ThreeSlotLayout
          rightSlot={
            <div className="flex flex-row gap-2">
              <PrimaryButton
                startIcon={<DynamicIcon nameIcon="AddRounded" size={25} className="text-white" />}
                onClick={() => viewModel.handleControleCentroCustoOpenState(null, true)}>
                Novo Item
              </PrimaryButton>
            </div>
          }
        />
      </PageTopBar>
      <div className="flex w-full gap-2 flex-col py-2 px-4 mb-20">
        <Breadcrumbs aria-label="breadcrumb" className="cursor-pointer">
          <Link underline="hover" color="inherit">
            Controle de Patrimônio
          </Link>
          <Typography className="text-primary-green">Controle</Typography>
        </Breadcrumbs>

        <div className="flex gap-2 items-center w-full">
          <h1 className="text-3xl font-medium text-black dark:text-white">Controle de Patrimônio</h1>
          <RefreshButton onClick={() => viewModel.handleReload()} />
        </div>

        <Header
          centrocusto={viewModel.filters.centroCusto}
          status={viewModel.filters.status}
          centrocustoDropDown={viewModel.centroCustoDropdown}
          onCentroCustoChange={viewModel.handleCentroCustoChange}
          onStatusChange={viewModel.handleStatusChange}
          onClear={viewModel.handleClear}
        />

        <StyledDataGrid
          tableName="maquinas_equip_controle_lista"
          disableColumnMenu={false}
          showToolbar={true}
          disableRowSelectionOnClick={true}
          getRowId={(row: GetAllControlePatrimonioControleDaoModel) => row.idControleCentroCusto ?? ""}
          columns={columnsDefinition}
          loading={viewModel.loading}
          checkboxSelection={false}
          rows={viewModel.controleCentroCusto}
          rowCount={viewModel.controleCentroCusto.length}
          pageSizeOptions={[10, 25, 50, 100]}
          pinnedColumns={{
            right: ["idMateriaisControlados"],
          }}
          paginationMode="server"
          paginationModel={{
            page: viewModel.pagination.page,
            pageSize: viewModel.pagination.rowsPerPage,
          }}
        />

        <TablePagination
          component="div"
          count={viewModel.pagination.totalItems}
          page={viewModel.pagination.page - 1}
          onPageChange={(_, p) => viewModel.handlePageChange(p)}
          rowsPerPageOptions={[10, 25, 50, 100]}
          rowsPerPage={viewModel.pagination.rowsPerPage}
          onRowsPerPageChange={(e) => viewModel.handleRowsPerPageChange(parseInt(e.target.value))}
        />
      </div>

      <ModalCreateMaquinasequipControle
        open={viewModel.controleCentroCustoModal}
        saving={viewModel.saving}
        loading={viewModel.loading}
        selectedControleCentroCusto={viewModel.selectedControleCentroCusto}
        centroCustoDropdown={viewModel.centroCustoDropdown}
        onClose={() => viewModel.handleControleCentroCustoOpenState(null, false)}
        onSubmit={viewModel.handleControleCentroCustoSubmit}
      />

      <DeleteDialog
        open={viewModel.controleCentroCustoDeleteModal}
        onClose={() => viewModel.handleControleCentroCustoDeleteOpenState(null, false)}
        title={`Você realmente deseja excluir este item?`}
        onDelete={viewModel.handleControleCentroCustoDeleteSubmit}
      />
    </>
  );
};
